
import Vue, {CreateElement, VNode} from 'vue'

export default Vue.extend({
    props: {
        loading: { default: false},
        type: {default: 'list'}
    },

    render(h): VNode {
        if (this.loading)
            return this.skeleton(h)
        else {
            return this.slot(h)
        }
    },

    methods: {
        /**
         * Use a render function so we can avoid an unecessary wrapper element
         * if the slot is a single VNode.
         */
        slot(h: CreateElement): VNode {
            const slot = this.$slots.default

            if (!slot)
                return h('div')
            else if (Array.isArray(slot))
                if (slot.length == 1)
                    return slot[0]
                else
                    return h('div', slot)
            else
                return slot
        },
        skeleton(h: CreateElement): VNode {
            return h('div', {
                attrs: {
                    'role': 'alert',
                    'aria-busy': true,
                    'aria-live': 'polite',
                },
                class: ['skeleton', `skeleton--${this.type}`]
            })
        }
    }
})
